import React, { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DateFormatCell, formatDateForAPI, getFormattedDateTime } from "components/common/formatter.js";
import styles from "./Casefile.module.scss";
import { HandleGridBody } from "components/common/HandleGridBody";
import FilterComponent from "components/CaseFiles/FilterComponent";
import { RedirectCell, GRID_PAGE_SIZES } from "components/common/GridComponents";
import { Popup } from "@progress/kendo-react-popup";
import CaseTaskForm from "./CaseTaskForm";
import { useCompany } from "services/companyService";
import { useAccessRight, CaseAccessRights } from "../../components/UserAccessRights.ts";
import { AiOutlineWarning } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import { Button } from "@progress/kendo-react-buttons";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import { updateMatterTask } from "api";
import { toast } from "react-toastify";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";
import { Tooltip } from "@progress/kendo-react-tooltip";

export default function CaseTasks(props) {
    const date = new Date();

    const [valueFrom, setValueFrom] = useState(false);
    const [valueTo, setValueTo] = useState(false);
    const [taskList, setTaskList] = useState({ data: [], total: 20 });
    const [isRefreshed, setIsRefreshed] = useState(false);
    const [eventDataState, setEventDataState] = useState();

    const { data: company } = useCompany();
    let yearsStartDate = new Date(company.yearStartDate);
    const [fromDate, setFromDate] = useState(formatDateForAPI(yearsStartDate));

    const [toDate, setToDate] = useState(formatDateForAPI(date));
    const [updateFilter, setUpdateFilter] = useState(false);
    const [dataState, setDataState] = useState({
        take: 50,
        skip: 0,
        sort: [
            {
                field: "date",
                dir: "asc",
            },
        ],
    });

    const [fromDateSelector, setFromDateSelector] = useState(yearsStartDate);
    const [toDateSelector, setToDateSelector] = useState(date);
    const [completed, setCompleted] = useState(false);

    const [viewTask, setViewTask] = useState();
    const [isView, setView] = useState(false);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [taskToDelete, setTaskToDelete] = useState(null);
    const [deletingTask, setDeletingTask] = useState(false);

    const [showCompleteConfirm, setShowCompleteConfirm] = useState(false);
    const [taskToComplete, setTaskToComplete] = useState(null);
    const [completingTask, setCompletingTask] = useState(false);
    const canDeleteTask = useAccessRight(CaseAccessRights.DeleteTasks);

    const createState = (skip, take) => {
        let pagerSettings = {
            pageSizes: GRID_PAGE_SIZES,
        };
        return {
            pageSize: take,
            pageable: pagerSettings,
        };
    };
    const [state, setState] = useState(createState(0, 50));

    const dataStateChange = (e) => {
        const eventObject = { event: e?.dataState };
        setEventDataState(eventObject);
        if (
            e.dataState.sort !== undefined &&
            e.dataState.skip !== 0 &&
            dataState.sort !== e.dataState.sort
        ) {
            setDataState({ ...e.dataState, skip: 0 });
        } else if (e.dataState.sort[0] === undefined) {
            setDataState({
                ...e.dataState,
                sort: [
                    {
                        field: dataState.sort[0].field,
                        dir: "asc",
                    },
                ],
            });
        } else {
            setDataState(e.dataState);
        }
        setUpdateFilter(true);
    };

    const dataReceived = (data) => {
        if (data) {
            setTaskList(data);
        }
    };

    const handleRefresh = () => {
        if (eventDataState) {
            setDataState({
                ...eventDataState?.event,
                skip: 0,
            });
        } else {
            setDataState({
                ...dataState,
                take: 50,
                skip: 0,
            });
        }
        setIsRefreshed(!isRefreshed);
        setUpdateFilter(true);
    };

    const Redirect = (prop) => (
        <RedirectCell
            handleClick={() => {
                props?.setAddTask(true);
                setViewTask(prop.dataItem);
                setView(true);
            }}
            title="View Task"
        />
    );

    useEffect(() => {
        if (props.refreshClicked && props.activeItem === 2) {
            handleRefresh();
            props?.setRefreshClicked(false);
        }
    }, [props?.refreshClicked]);

    const onOpen = () => { };

    useEffect(() => {
        if (!props?.filterClicked) return;

        const handlePointerDown = (event) => {
            const anchorElement = props?.filterAnchor?.current;
            if (anchorElement && anchorElement.contains(event.target)) {
                return;
            }
            if (event.target?.closest?.(".k-calendar")) {
                return;
            }

            if (event.target?.closest?.(".k-popup")) {
                return;
            }

            const popupElement = props?.filterContentRef?.current;
            const popupContainer = popupElement
                ? popupElement.closest(".k-animation-container")
                : null;
            const rect =
                popupContainer?.getBoundingClientRect?.() ||
                popupElement?.getBoundingClientRect?.();

            if (!rect) {
                props?.setFilterClicked(false);
                return;
            }

            const { clientX, clientY } = event;
            const isInside =
                clientX >= rect.left &&
                clientX <= rect.right &&
                clientY >= rect.top &&
                clientY <= rect.bottom;
            if (!isInside) {
                props?.setFilterClicked(false);
            }
        };

        document.addEventListener("pointerdown", handlePointerDown, true);
        return () => {
            document.removeEventListener("pointerdown", handlePointerDown, true);
        };
    }, [
        props?.filterClicked,
        props?.setFilterClicked,
        props?.filterAnchor,
        props?.filterContentRef,
    ]);

    useEffect(() => {
        if (updateFilter) {
            setUpdateFilter(false);
        }
    }, [updateFilter]);

    const onChangeFromDateSelect = (event) => {
        if (!valueFrom) {
            setValueFrom(true);
        }
        setFromDateSelector(event.value);
        let fromDate = null;
        let date = new Date(event.value);
        if (event.value) {
            fromDate = formatDateForAPI(date);
        }
        setFromDate(fromDate);
    };
    const handleStatusChange = (e) => {
        setCompleted(e.value);
    };

    const onChangeToDateSelect = (event) => {
        if (!valueTo) {
            setValueTo(true);
        }
        setToDateSelector(event.value);
        let toDate = null;
        let date = new Date(event.value);
        if (event.value) {
            toDate = formatDateForAPI(date);
        }
        setToDate(toDate);
    };

    const updateFilterValues = () => {
        const { setFilterClicked, setFilterApplied } = props;
        setUpdateFilter(true);
        setFilterClicked(false);

        if (!valueFrom && !valueTo && !completed) {
            setFromDateSelector(yearsStartDate);
            setToDateSelector(date);
            setFilterApplied(false);
            return;
        }
        setFilterApplied(true);
    };

    const handleReset = () => {
        setUpdateFilter(true);
        setValueFrom(false);
        setValueTo(false);
        setFromDateSelector(yearsStartDate);
        setToDateSelector(date);
        setCompleted(false);
        props?.setFilterApplied(false);
        props?.setFilterClicked(false);
    };


    const rowRender = (trElement, props) => {
        const item = props.dataItem;

        let className = trElement.props.className || "";

        if (item.isOverdue) {
            className += " row-font-red ";
        } else if (item.isDueToday) {
            className += " row-font-green ";
        }

        return React.cloneElement(trElement, {
            ...trElement.props,
            className: className.trim()
        });
    };

    const DueDateCell = (cellProps) => {
        const { dataItem, field } = cellProps;
        const dateValue = dataItem?.[field];

        let cellStyle = {};
        if (dataItem.isOverdue) {
            cellStyle = { fontWeight: "500" };
        } else if (dataItem.isDueToday) {
            cellStyle = { fontWeight: "500" };
        }


        const { date, time } = getFormattedDateTime(dateValue, company?.locale);

        return (
            <td style={cellStyle}>
                <span className="d-flex align-items-center gap-1">
                    <span className="d-flex flex-column">
                        <span>{date}</span>
                        {time && <span>{time}</span>}
                    </span>
                    {dataItem.isOverdue && (
                        <AiOutlineWarning size={16} title="Overdue" />
                    )}
                </span>
            </td>
        );
    };

    const handleDeleteClick = (dataItem) => {
        if (!dataItem?.taskId) return;
        setTaskToDelete(dataItem);
        setShowDeleteConfirm(true);
    };

    const confirmDeleteTask = async () => {
        if (!taskToDelete?.taskId) {
            setShowDeleteConfirm(false);
            setTaskToDelete(null);
            return;
        }
        setDeletingTask(true);
        try {
            await updateMatterTask(taskToDelete.taskId, { active: false });
            toast.success("Task removed");
            handleRefresh();
        } catch (err) {
            console.error(err);
        } finally {
            setShowDeleteConfirm(false);
            setTaskToDelete(null);
            setDeletingTask(false);
        }
    };

    const handleCompleteClick = (dataItem) => {
        if (!dataItem?.taskId) return;
        setTaskToComplete(dataItem);
        setShowCompleteConfirm(true);
    };

    const confirmCompleteTask = async () => {
        if (!taskToComplete?.taskId) {
            setShowCompleteConfirm(false);
            setTaskToComplete(null);
            return;
        }
        setCompletingTask(true);
        try {
            await updateMatterTask(taskToComplete.taskId, { completed: true });
            toast.success("Task marked as complete");
            handleRefresh();
        } catch (err) {
            console.error(err);
        } finally {
            setShowCompleteConfirm(false);
            setTaskToComplete(null);
            setCompletingTask(false);
        }
    };

    const CompletedStatusCell = (prop) => {
        if (!prop.dataItem?.taskId) return <td />;
        const isAlreadyCompleted = prop.dataItem?.completed;
        return (
            <td className="text-center">
                {isAlreadyCompleted ?
                    <FaCheckCircle
                        size={16}
                        color="#6EC871"
                    /> : <FaRegCircle
                        size={16}
                        color="#c9c9c9"
                    />}
            </td>
        );
    };

    const CompleteTaskCell = (prop) => {
        if (!prop.dataItem?.taskId || prop.dataItem?.completed) return <td />;
        return (
            <td className="text-center">
                <Tooltip anchorElement="target" position="top" parentTitle>
                    <span title="Mark as complete">
                        <FaCheckCircle
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCompleteClick(prop.dataItem);
                            }}
                            size={16}
                            color="#6EC871"
                            className="cursor-pointer"
                            aria-hidden
                        />
                    </span>
                </Tooltip>
            </td>
        );
    };

    const DeleteTaskCell = (prop) => {
        if (!prop.dataItem?.taskId) return <td />;
        return (
            <td className="text-right">
                <Tooltip anchorElement="target" position="top" parentTitle>
                    <Button
                        className="btn m-0 p-0 border-0"
                        title="Remove task"
                        disabled={!canDeleteTask}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteClick(prop.dataItem);
                        }}
                    >
                        <RxCross2 size={15} color={canDeleteTask ? "red" : "#ccc"} aria-hidden />
                    </Button>
                </Tooltip>
            </td>
        );
    };

    return (
        <div className="h-100 ">
            <Grid
                {...dataState}
                data={taskList}
                onDataStateChange={dataStateChange}
                sortable={true}
                className="fs-md h-100"
                pageable={state.pageable}
                pageSize={state.pageSize}
                rowRender={rowRender}
            >
                <GridColumn field="date" title="Date" cell={DateFormatCell} width="120px" />
                <GridColumn field="addedByUserRef" title="By" width="70px" />
                <GridColumn field="feeEarnerRef" title="FE" width="70px" />
                <GridColumn field="details" title="Details" />
                <GridColumn
                    title="Completed"
                    width="110px"
                    cell={CompletedStatusCell}
                    headerClassName="text-center"
                />
                <GridColumn
                    field="dateDueBy"
                    title="Due By"
                    cell={DueDateCell}
                    width="150px"
                />
                <GridColumn width="32" cell={Redirect} />
                <GridColumn
                    width="28"
                    cell={CompleteTaskCell}
                    headerClassName="text-center"
                />
                <GridColumn
                    width="45"
                    cell={DeleteTaskCell}
                    headerClassName="text-center"
                />
            </Grid>
            <Popup
                key={props?.filterClicked ? "open" : "closed"}
                show={props?.filterClicked}
                anchor={props?.filterAnchor?.current}
                anchorAlign={{
                    horizontal: "right",
                    vertical: "bottom",
                }}
                popupAlign={{
                    horizontal: "right",
                    vertical: "top",
                }}
                popupClass={`${styles["popup-content"]}`}
                onOpen={onOpen}>
                <div
                    ref={props?.filterContentRef}
                    role="menu"
                    className="d-flex flex-column align-items-center">
                    <FilterComponent
                        updateFilterValues={updateFilterValues}
                        setUpdateFilter={setUpdateFilter}
                        updateFilter={updateFilter}
                        showPopup={true}
                        valueFrom={valueFrom}
                        setValueFrom={setValueFrom}
                        fromDateSelector={fromDateSelector}
                        onChangeFromDateSelect={onChangeFromDateSelect}
                        valueTo={valueTo}
                        setValueTo={setValueTo}
                        toDateSelector={toDateSelector}
                        onChangeToDateSelect={onChangeToDateSelect}
                        handleChange={handleStatusChange}
                        completed={completed}
                        showCompleted={true}
                        handleReset={handleReset}
                    />
                </div>
            </Popup>
            <HandleGridBody
                matterId={props?.matterId}
                refresh={isRefreshed}
                updateFilter={updateFilter}
                completed={completed}
                fD={updateFilter && valueFrom ? fromDate : ""}
                tD={updateFilter && valueTo ? toDate : ""}
                dataState={dataState}
                onDataReceived={dataReceived}
                currentComponent="casefile-tasks"
            />

            {showCompleteConfirm && (
                <ConfirmationDialog
                    content="Are you sure you want to mark this task as complete?"
                    onClickYes={confirmCompleteTask}
                    onClickNo={() => {
                        setShowCompleteConfirm(false);
                        setTaskToComplete(null);
                    }}
                    onClose={() => {
                        setShowCompleteConfirm(false);
                        setTaskToComplete(null);
                    }}
                    isLoading={completingTask}
                />
            )}

            {showDeleteConfirm && (
                <ConfirmationDialog
                    content="Are you sure you want to remove this task?"
                    onClickYes={confirmDeleteTask}
                    onClickNo={() => {
                        setShowDeleteConfirm(false);
                        setTaskToDelete(null);
                    }}
                    onClose={() => {
                        setShowDeleteConfirm(false);
                        setTaskToDelete(null);
                    }}
                    isLoading={deletingTask}
                />
            )}

            {props?.addTask && (
                <CaseTaskForm
                    matterId={props?.matterId}
                    addFormText={props?.addFormText}
                    feeEarnerRef={props.matterDetails?.feeEarnerRef}
                    isView={isView}
                    setView={setView}
                    viewTask={viewTask}
                    isRefreshed={isRefreshed}
                    setIsRefreshed={setIsRefreshed}
                    setCloseModal={() => {
                        setViewTask("");
                        setView(false);
                        props.setAddTask(false);
                    }}
                />
            )}
        </div>
    );
}
